module.exports = __webpack_public_path__ + "static/img/img47.c763cae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/neighbourhood/img47.png
// module id = UMWZ
// module chunks = 1